import DomManipulate from "./DomManipulate";

export default class Countries {
    constructor(selector, msg, ...options) {
        this.selector = selector;
        this.msg = msg;
        this.elementToPopulate = options[0];
        this.userLang = document.documentElement.lang
    }

    init() {

        let dom = new DomManipulate();
        dom.onReady(() => {

            let selectPro = document.querySelector(this.elementToPopulate)
            if (!selectPro) {
                return
            }
            let attrSelect = selectPro.dataset.provinceDefault;
            let el = document.querySelector(this.selector)
            if (!el) {
                return
            }
            let valueOnInit = el.value;
            this.getProvincesByCountryCode(valueOnInit, attrSelect)
            dom.onChange(this.selector, (cbValue) => {
                this.getProvincesByCountryCode(cbValue);
            })

        })
    }

    getProvincesByCountryCode(selectedOption, attrSelect) {
        let userLang = this.userLang;
        let data = { country_code: selectedOption, "userLang": userLang };
        $.ajax({
            type: 'POST',
            url: '/ajax/get_provinces_by_country_code.php',
            data: data,
            dataType: 'json'
        })
            .done((result) => {
                if (Object.keys(result).length !== 0) {
                    $(this.elementToPopulate + " option").remove();
                    $(this.elementToPopulate).prop('disabled', false);
                    for (const [key, value] of Object.entries(result)) {
                        if (attrSelect === key) {
                            $(this.elementToPopulate).append('<option value="' + key + '" selected="selected">' + value + '</option>')
                        } else {
                            $(this.elementToPopulate).append('<option value="' + key + '">' + value + '</option>');
                        }
                    }
                } else if (Object.keys(result).length === 0) {
                    $(this.elementToPopulate + " option").remove();
                    $(this.elementToPopulate).prop('disabled', true);

                }
                else {
                    $(this.msg).addClass('d-block text-danger').text('error');
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.log('internal server error on login')
            });
    }

}
